import get from 'lodash/get';

import { isConnectedToBrandAgencyOrganization, isPlainBrandAgencyOrganization } from 'utils/organization';
import { isZalandoOutfitOnly } from 'utils/deliverables';

import type { State } from 'types';

export const contentApprovalLinkSelector = (state: State): string | undefined | null => {
  const { organizations, campaignDeliverables } = state;

  if (isZalandoOutfitOnly(campaignDeliverables.deliverables)) {
    return null;
  }

  if ((isPlainBrandAgencyOrganization(organizations.currentOrganization)
    || isConnectedToBrandAgencyOrganization(organizations.currentOrganization))
  ) {
    return get(state, 'campaignBrief.brief.contentApprovalLink', '');
  }

  return null;
};
